module.exports = __webpack_public_path__ + "img/import.3f751fa1.svg";